export function ProductFaqCollapseInit() {
    const productFaqWrapperQuery = '.c-product-faq-wrapper';
    const buttonQuery = '.c-product-faq-more-less-btn';

    /**
     * @type
     */
    const showHideButtons = document.querySelectorAll(buttonQuery);

    /**
     * @type NodeListOf<HTMLDivElement>
     */
    const productFaqWrappers = document.querySelectorAll(productFaqWrapperQuery);

    if(showHideButtons && productFaqWrappers){

        showHideButtons.forEach(bt => bt.addEventListener('click', (el) => {
            if(productFaqWrappers[0].classList.contains('is-open')) {
                productFaqWrappers.forEach(pw => pw.classList.remove('is-open'));
                showHideButtons.forEach(button => button.innerText = 'Zobacz więcej');

            } else {
                productFaqWrappers.forEach(pw => pw.classList.add('is-open'));
                showHideButtons.forEach(button => button.innerText = 'Zobacz mniej');
            }
        }))
    }

}
